import { render } from "../views/footer.html?vue&type=template&id=00cfe97d&ts=true&external"
import script from "../scripts/footer.ts?vue&type=script&lang=ts&external"
export * from "../scripts/footer.ts?vue&type=script&lang=ts&external"

import "../css_builds/components/input.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ClientApp/components/footer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "00cfe97d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('00cfe97d', __exports__)) {
    api.reload('00cfe97d', __exports__)
  }
  
  module.hot.accept("../views/footer.html?vue&type=template&id=00cfe97d&ts=true&external", () => {
    api.rerender('00cfe97d', render)
  })

}


export default __exports__